import { h } from "preact";
import styled from "styled-components";
import {gridSize} from "../style-variables";

const LoadingIndicatorContainer = styled.span`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
`

export const LoadingIndicator = () => <LoadingIndicatorContainer><strong> Loading... </strong> </LoadingIndicatorContainer>